import { Form, FormInstance, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import { useRef, useState, useEffect } from 'react';
import { studioApply } from '../../../api';
// import { ModalWrap } from '../../../components/modal-wrap';
import { ModalWrap } from '../../component/modal-wrap';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../components/message';
import { CodeStudio } from '../../../model/api-modules';
import getFormatMessage from '../../../locales/get-format-message';
interface IProps {
  readonly onClose: () => void;
}

export const ApplyToJoinModal = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const formRef = useRef<FormInstance<any>>(null);

  useEffect(() => {
    const head: HTMLElement | null =
      document.querySelector('.gc-page-headline');
    if (head) {
      head.style.zIndex = '100';
    }
  }, []);

  const onOk = async () => {
    if (!formRef.current?.validateFields()) return false;
    setLoading(true);
    try {
      const values = await formRef.current.validateFields();
      const res = await studioApply(values.StudioId, values.Reason);
      if (res && res.code === 0) {
        messageSuccess(getFormatMessage('studio_application_sent_success'));
        formRef.current?.resetFields();
        onClose(); // 关闭弹窗
      } else if (res.code === CodeStudio.StudioApplyTimeScopeFail) {
        messageWarning(getFormatMessage('studio_invitation_already_sent'));
        // formRef.current?.resetFields(); // 清空
      } else if (res.code === CodeStudio.StudioNotExist) {
        messageWarning(getFormatMessage('studio_not_exist'));
      } else if (res.code === CodeStudio.OnlyJoinOneStudio) {
        messageWarning(getFormatMessage('only_join_one'));
      } else if (res.code === CodeStudio.MemberInviteUserExistStudioFail) {
        messageWarning(getFormatMessage('already_joined_this_studio'));
      } else {
        messageError(getFormatMessage('fail_to_apply'));
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
    return true; // 添加明确的返回语句
  };

  const onClose = () => {
    const head: HTMLElement | null =
      document.querySelector('.gc-page-headline');
    if (head) {
      head.style.zIndex = '999';
    }
    props.onClose();
  };

  const renderForm = () => {
    return (
      <Form
        ref={formRef}
        className="c-main-form"
        name="basic"
        initialValues={{ remember: true }}
        autoComplete="off"
        layout="vertical"
        colon={false}
        requiredMark={false}
      >
        <Form.Item
          label={getFormatMessage('studio_id')}
          name="StudioId"
          rules={[
            {
              required: true,
              message: getFormatMessage('please_enter_studio'),
            },
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }
                if (/^\d+$/.test(value)) {
                  return Promise.resolve(); // 合法
                }
                return Promise.reject(
                  new Error(getFormatMessage('only_numbers'))
                );
              },
            },
          ]}
        >
          <Input
            className="c-antd-input-xl-main"
            placeholder={getFormatMessage('please_enter_studio_id')}
            autoFocus
            spellCheck="false"
          />
        </Form.Item>
        <Form.Item
          label={getFormatMessage('reason')}
          name="Reason"
          rules={[
            {
              required: true,
              message: getFormatMessage('please_enter_reason_desc'),
            },
          ]}
        >
          <TextArea
            className="c-antd-input-xl-main"
            placeholder={getFormatMessage('please_enter_reason')}
            style={{ paddingTop: '9px' }}
            autoSize={{ minRows: 5 }}
          />
        </Form.Item>
      </Form>
    );
  };

  return (
    <ModalWrap
      onOk={onOk}
      cancelText={getFormatMessage('cancel')}
      width="480px"
      onClose={onClose}
      oKText={getFormatMessage('send')}
      title={getFormatMessage('apply_to_join_upper')}
      loading={loading}
    >
      {renderForm()}
    </ModalWrap>
  );
};
